<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
    </div>
  </div>
</template>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "工人姓名",
          key: "workerName",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "性别",
          key: "gender",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件类型",
          key: "idCardType",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件号码",
          key: "idCardNumber",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "民族",
          key: "nation",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "住址",
          key: "address",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "头像",
          minWidth: 210,
          tooltip: true,
          align: "center",
          render: (h) => {
            return h("img", {
              attrs: {
                src: "headImage",
              },
              style: {
                width: "180px",
                height: "100px",
              },
            });
          },
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "近照",
          key: "recentHeadImage",
          align: "center",
          minWidth: 210,
          render: (h) => {
            return h("img", {
              attrs: {
                src: "recentHeadImage",
              },
              style: {
                width: "180px",
                height: "100px",
              },
            });
          },
        },
        {
          title: "政治面貌",
          key: "politicsType",
          minWidth: 120,
          align: "center",
        },
        {
          title: "加入工会时间",
          key: "joinedTime",
          align: "center",
          minWidth: 180,
        },
        {
          title: "手机号码",
          key: "cellPhone",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "文化程度",
          key: "cultureLevelType",
          align: "center",
          minWidth: 100,
          tooltip: true
        },
        {
          title: "特长",
          key: "Specialty",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "是否有重大病史紧急联系人姓名",
          key: "hasBadMedicalHistory",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "紧急联系方式",
          key: "urgentLinkManPhone",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "开始工作日期",
          key: "workDate",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "婚姻状况",
          key: "maritalStatus",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },

        {
          title: "发证机关",
          key: "grantOrg",
          align: "center",
          minWidth: 180,
          tooltip: true
        },
        {
          title: "正面照",
          key: "positiveIDCardImage",
          align: "center",
          minWidth: 210,
          render: (h) => {
            return h("img", {
              attrs: {
                src: "positiveIDCardImage",
              },
              style: {
                width: "180px",
                height: "100px",
              },
            });
          },
        },
        {
          title: "反面照",
          key: "negativeIDCardImage",
          align: "center",
          minWidth: 210,
          render: (h) => {
            return h("img", {
              attrs: {
                src: "negativeIDCardImage",
              },
              style: {
                width: "180px",
                height: "100px",
              },
            });
          },
        },
        {
          title: "证件有效期开始日期",
          key: "startDate",
          align: "center",
          minWidth: 180,
        },
        {
          title: "证件有效期结束日期",
          key: "expiryDate",
          align: "center",
          minWidth: 180,
        },
        {
          title: "数据来源",
          key: "sourceAreaCode",
          align: "center",
          minWidth: 140,
        },
      ],
    };
  },
  mounted() {},
};
</script>
